import { Modal } from 'antd';
import React from 'react';
import { ThirdPartyForProposalType } from './ThirdPartyInput';
import ThirdPartySearch, {
  ThirdPartySearchProps,
} from '../pages/ThirdParty/TpList';

export type ThirdPartySearchModalProps = Pick<
  ThirdPartySearchProps,
  'initialSearchParams' | 'onSelect'
> & {
  visible: boolean;
  onCancel: () => void;
  isProposalCreate: boolean;
  hideThirdPartyModal?: () => void;
  setThirdPartyForProposal?: (
    thirdPartyForProposal: ThirdPartyForProposalType
  ) => void;
  parcodeRole?: string;
  title?: string;
  tpid?: number;
};

const ThirdPartySearchModal = ({
  onCancel,
  visible,
  initialSearchParams,
  onSelect,
  parcodeRole,
  isProposalCreate,
  hideThirdPartyModal,
  setThirdPartyForProposal,
  title,
  tpid,
}: ThirdPartySearchModalProps) => {
  return (
    (<Modal
      open={visible}
      onCancel={onCancel}
      width={1200}
      destroyOnClose
      footer={null}
      title={title ?? []}
    >
      <ThirdPartySearch
        sameTpid={tpid}
        isModal="true"
        parcodeRole={parcodeRole}
        onSelect={onSelect}
        initialSearchParams={initialSearchParams}
        isProposalCreate={isProposalCreate}
        setThirdPartyForProposal={setThirdPartyForProposal}
        hideThirdPartyModal={hideThirdPartyModal}
      />
    </Modal>)
  );
};

export default ThirdPartySearchModal;
